import React from 'react'
import Animation from './Animation'
import BaseSkeletonLoader from './BaseSkeleton'

const TableLoader = ({ theme }) => {
  const themeClass = theme || 'light'

  return (
    <td>
      <div className={`skeleton-wrapper ${themeClass}`}>
        <div className="skeleton-table">
          <BaseSkeletonLoader type="table" />
          <BaseSkeletonLoader type="text" />
          <BaseSkeletonLoader type="text" />
          <BaseSkeletonLoader type="text" />
          <BaseSkeletonLoader type="pagination" />
          <Animation />
        </div>
      </div>
    </td>
  )
}

export default TableLoader
